const BASE = process.env.REACT_APP_API_URL || '/api';

function token() {
  return localStorage.getItem('gc_admin_token');
}

async function request(method, path, body, isFormData = false) {
  const headers = { Authorization: `Bearer ${token()}` };
  if (!isFormData) headers['Content-Type'] = 'application/json';

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: isFormData ? body : (body ? JSON.stringify(body) : undefined),
  });

  if (res.status === 401) {
    localStorage.removeItem('gc_admin_token');
    window.location.reload();
    throw new Error('No autorizado');
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || `Error ${res.status}`);
  return data;
}

export const api = {
  // ─── auth ───
  login: (email, password) =>
    fetch(`${BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    }).then(async r => {
      const data = await r.json();
      if (!r.ok) throw new Error(data.message || 'Error');
      if (!data.user.isAdmin) throw new Error('Esta cuenta no tiene acceso al panel');
      return data;
    }),

  me: () => request('GET', '/auth/me'),

  // ─── dashboard ───
  dashboard: () => request('GET', '/admin/dashboard'),
  statsClasses: () => request('GET', '/admin/stats/classes'),
  statsPatients: () => request('GET', '/admin/stats/patients'),

  // ─── patients ───
  patients: {
    list:   ()        => request('GET',    '/admin/patients'),
    get:    (id)      => request('GET',    `/admin/patients/${id}`),
    create: (data)    => request('POST',   '/admin/patients', data),
    update: (id, data) => request('PUT',   `/admin/patients/${id}`, data),
    deactivate: (id)  => request('DELETE', `/admin/patients/${id}`),
  },

  // ─── subscriptions ───
  subscriptions: {
    list:   (params = {})  => {
      const q = new URLSearchParams(params).toString();
      return request('GET', `/admin/subscriptions${q ? '?' + q : ''}`);
    },
    create: (data)         => request('POST',   '/admin/subscriptions', data),
    update: (id, data)     => request('PUT',    `/admin/subscriptions/${id}`, data),
    remove: (id)           => request('DELETE', `/admin/subscriptions/${id}`),
  },

  // ─── classes ───
  classes: {
    list:   ()        => request('GET',    '/admin/classes'),
    get:    (id)      => request('GET',    `/admin/classes/${id}`),
    create: (data)    => request('POST',   '/admin/classes', data),
    update: (id, data) => request('PUT',   `/admin/classes/${id}`, data),
    remove: (id)      => request('DELETE', `/admin/classes/${id}`),
    uploadImage: (id, file) => {
      const fd = new FormData();
      fd.append('image', file);
      return request('POST', `/admin/classes/${id}/image`, fd, true);
    },
  },

  // ─── audios ───
  audios: {
    upload: (classId, files) => {
      const fd = new FormData();
      [...files].forEach(f => fd.append('audio', f));
      return request('POST', `/admin/classes/${classId}/audio`, fd, true);
    },
    update: (id, data) => request('PUT',    `/admin/audio/${id}`, data),
    remove: (id)       => request('DELETE', `/admin/audio/${id}`),
  },
};
